import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import * as $ from 'jquery';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { of } from 'rxjs/observable/of';
//import { KonvaComponent } from 'ng2-konva';

//import * as shape from 'd3-shape';
//import { NgxGraphModule } from '@swimlane/ngx-graph';

//declare const Konva: any;
//let ng: any;

//import 'rxjs/add/observable/of';
//// or 

@Component({
  selector: 'app-data-visualizer',
  templateUrl: './data-visualizer.component.html',
  styleUrls: ['./data-visualizer.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class DataVisualizerComponent implements OnInit {

    hierarchialGraph = { nodes: [], links: [] }
    //curve = shape.curveBundle.beta(1);
/*    curve = shape.curveStepAfter;*/
    colorScheme: string = "vivid";
    view: any[];
    width: number = 700;
    height: number = 300;

    @ViewChild('stage', {static: true}) stage: any;
    @ViewChild('layer', {static: true}) layer: any;
    @ViewChild('text', {static: true}) text: any;

    data: any = [
        {
            name: "Assessment.Name",
            filter: "",
            sort: ""
        },
        {
            name: "Coach.Name",
            filter: "",
            sort: ""
        },
        {
            name: "Purchase.Date",
            filter: ">= 04/01/2018",
            sort: "DESC"
        }
    ]; 

    inBounds = true;
    ngDraggable = true;
    edge = {
        top: true,
        bottom: true,
        left: true,
        right: true
    };

    movingOffset = { x: 0, y: 0 };
    endOffset = { x: 0, y: 0 };

    list: Array<any> = [];
    listText: Array<any> = [];
    listLines: Array<any> = [];


    constructor() { }
    
    ngOnInit() {
        for (let n = 0; n < 3; n++) {

            let x = Math.random() * 800;
            let y = Math.random() * 200;

            this.add(x, y);
        }

        this.showGraph();
        this.view = [this.width, this.height];
    }

    showGraph() {
        this.hierarchialGraph.nodes = [
            {
                id: 'start',
                label: 'Assessments',
                position: 'x0',
            }, {
                id: '1',
                label: 'Coaches',
                position: 'x1',
            }, {
                id: '2',
                label: 'Purchases',
                position: 'x2',
            }
        ];

        this.hierarchialGraph.links = [
            {
                source: 'start',
                target: '1',
                label: 'links to'
            }, {
                source: 'start',
                target: '2'
            }
        ];
    }

    select(data) {
        console.log('Item clicked', data);
    }






    configStage: Observable<any> = of({
        container: 'container',
        width: window.innerWidth,
        height: 200
    });

    handleClick(component) {
        console.log("component", component);
        console.log('getStage', component.getStage());
        console.log('stage', this.stage);
        console.log('layer', this.layer);
        console.log('text', this.layer._stage.children[(component.getStage().index + 3)].setX(component.getStage().getX()));
        console.log('text', this.layer._stage.children[(component.getStage().index + 3)].setY(component.getStage().getY()));

        //component.getStage().setX(50);
        this.layer.getStage().draw();

    }

    handleMove(component) { 
        console.log(component);
        let index = component.getStage().index + this.list.length;
        let parentX = component.getStage().getX();
        let parentY = component.getStage().getY();
        console.log('text', this.layer._stage.children[index].setX((parentX + 10)));
        console.log('text', this.layer._stage.children[index].setY((parentY + 5)));
    }

    add(x:number, y:number) {
        this.list.push(
            new BehaviorSubject({
                x: x,
                y: y,
                width: 100,
                height: 30,
                fill: '#3cb5d5',
                stroke: 'black',
                strokeWidth: 1,
                draggable: true
            })
        );

        this.listText.push(
            new BehaviorSubject({
                x: (x + 10),
                y: (y + 5),
                fontFamily: 'Calibri',
                fontSize: 18,
                text: 'TEXT ' + (this.list.length),
                fill: 'white',
                draggable: false
            })
        );

        this.listLines.push(
            new BehaviorSubject({
                points: [5, 10, 100, 110, 150, 160],
                stroke: 'black',
                strokeWidth: 5,
                lineCap: 'round',
                lineJoin: 'round'
            })
        );



        console.log(this.list);
        console.log(this.listText);
    }

    addNew(type:string) {
        //console.log('add new');
        //let x = Math.random() * 800;
        //let y = Math.random() * 200;
        //this.add(x, y);
        //this.layer.getStage().draw();

        let id = this.hierarchialGraph.nodes.length + 1;

        this.hierarchialGraph.nodes.push({
            id: id.toString(),
            label: type
        });

        this.hierarchialGraph.links.push({
            source: 'start',
            target: id.toString()
        });

        this.hierarchialGraph.nodes = [...this.hierarchialGraph.nodes]
        this.hierarchialGraph.links = [...this.hierarchialGraph.links]

        console.log(this.hierarchialGraph);
    }

  checkEdge(event) {
      //this.edge = event;
      //console.log('edge:', event);
  }

  onStart(event) {
      //console.log('started output:', event);
  }

  onStop(event) {
      //console.log('stopped output:', event);
  }

  onMoving(event) {
      this.movingOffset.x = event.x;
      this.movingOffset.y = event.y;
      console.log("movingOffset x: ",this.movingOffset.x);
      console.log("movingOffset y: ", this.movingOffset.y);
  }

  onMoveEnd(event) {
      this.endOffset.x = event.x;
      this.endOffset.y = event.y;
      console.log("endOffset x: ", this.endOffset.x);
      console.log("endOffset y: ",this.endOffset.y);
  }

  moveUp(index, arrayName) {
      if (index > 0) {
          const tmp = arrayName[index - 1];
          arrayName[index - 1] = arrayName[index];
          arrayName[index] = tmp;
      }
  }

  moveDown(index, arrayName) {
      if (index + 1 == arrayName.length) {
          return;
      }
      if (index < arrayName.length) {
          const tmp = arrayName[index + 1];
          arrayName[index + 1] = arrayName[index];
          arrayName[index] = tmp;
      }
  }

  deleteRow(index, arrayName) {
      arrayName.splice(index, 1);
      console.log(arrayName);
  }

  insertNewRow(text: string) {
      var element: any = {};
      element.name = text;
      element.filter = '';
      element.sort = '';

      let contains = this.containsObject(element, this.data);
      if (text == "") {
          return;
      }
      //var exist = this.data.indexOf(element);
      if (contains) {
          //alert("This Tag is already exist");
          //return;
      } else {
          this.data.push(element);
          console.log(this.data);
          $('#tagInput').val('');
      }
  }

  containsObject(obj, list) {
        var i;
        for (i = 0; i < list.length; i++) {
            if (JSON.stringify(list[i]) === JSON.stringify(obj) ) {
                return true;
            }
        }

        return false;
    }    

}
